export const clientSearchSiteCoreKeys = {
  header: "ClientManagement.SearchClientComponent.SearchClientHeader",
  headerNewClient: "ClientManagement.SearchClientHeader.NewClient",
  searchFormKey: "ClientManagement.SearchClientComponent.SearchClient",
  searchFilterByList: "ClientManagement.SearchClient.FilterByList",
  companyNameLabel: "ClientManagement.SearchClient.CompanyName",
  clientCodeLabel: "ClientManagement.SearchClient.ClientCode",
  countryLabel: "ClientManagement.SearchClient.AddressCountry",
  cityLabel: "ClientManagement.SearchClient.City",
  statusLabel: "ClientManagement.SearchClient.Status",
  statusList: "ClientManagement.SearchClient.StatusList",
  result: "ClientManagement.SearchClientComponent.ClientResults",
  companyNameHeader: "ClientManagement.ClientResults.CompanyName",
  clientCodeHeader: "ClientManagement.ClientResults.ClientCode",
  countryHeader: "ClientManagement.ClientResults.AddressCountry",
  cityHeader: "ClientManagement.ClientResults.City",
  hierarchyHeader: "ClientManagement.ClientResults.Hierarchy",
  noHierarchyMessage: "ClientManagement.SearchClient.NoHierarchyMessage",
  noHierarchyImage: "ClientManagement.SearchClient.NoHierarchyImage",
  smallImage: "SmallImage",
  locationHeader: "ClientManagement.ClientResults.Location",
  hierarchyPopUpHeading: "ClientManagement.ClientResults.HierarchyPopUpHeading",
  contains: "FilterBy.Contains",
  noHierarchyTagParent: "ClientManagement.SearchClient.NoHierarchyTagParent",
  clientType: "ClientManagement.SearchClient.ClientType",
  clientTypeList: "ClientManagement.SearchClient.ClientTypeList",
  clientTypeResults: "ClientManagement.ClientResults.ClientType",
  clientTypeListResults: "ClientManagement.ClientResults.ClientTypeList",
};
